import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { ForYou } from './components/sections/ForYou';
import { Manuals } from './components/sections/Manuals';
import { InstantAccess } from './components/sections/InstantAccess';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Testimonials } from './components/sections/Testimonials';
import { Guarantee } from './components/sections/Guarantee';
import { Mission } from './components/sections/Mission';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full bg-ink-950" data-id="element-0" data-mp="23v2rsz5cwt3a">
      <MetaPixel data-id="element-1" data-mp="3ik7eyd5x05p2" />
      <Hero data-id="element-2" data-mp="3ikqy1x7ax04o" />
      <main data-id="element-3" data-mp="3ij652c0mxp8x">
        <BeforeAfter data-id="element-4" data-mp="3ijfvg0pldyf5" />
        <ForYou data-id="element-5" data-mp="3ihuyy5jpw5en" />
        <Manuals data-id="element-6" data-mp="3mlj6wpc9h30f" />
        <InstantAccess data-id="element-7" data-mp="3ml17xky7saot" />
        <Bonuses data-id="element-8" data-mp="3mk852v2dm5by" />
        <Offer data-id="element-9" data-mp="3mjq2zht18ww4" />
        <Testimonials data-id="element-10" data-mp="3mj6hjr46bqdc" />
        <Guarantee data-id="element-11" data-mp="3rcj846sey78q" />
        <Mission data-id="element-12" data-mp="3rbzpsoyupgu6" />
        <Faq data-id="element-13" data-mp="3rdkkqfp2v1sk" />
        <FinalCta data-id="element-14" data-mp="3rd19fhtxnbni" />
      </main>
      <Footer data-id="element-15" data-mp="5yh2n2cyzbp" />
      <FloatingCta data-id="element-16" data-mp="6hovayao7c0" />
      <PurchasePopup data-id="element-17" data-mp="4ww9qvjiygs" />
    </div>;
}